/**
 * @fileoverview The report citation context, outside ReportEditor.tsx so that
 * file exports only components (react-refresh/only-export-components).
 */

import { createContext } from "react";

/**
 * Lets a document-kind citation chip open the detailed document view in-place
 * (a slideout) rather than navigating away, and controls whether inline
 * citation chips are shown at all (source-display mode).
 */
export const ReportCitationContext = createContext<{
  onDocumentClick?: (documentId: string) => void;
  /**
   * Opens a cited POD claim's detail panel in-place (an overlay) rather than
   * navigating to the Recoveries phase — so a reader reviewing the report
   * doesn't lose their place (MOR).
   */
  onPodClaimClick?: (claimId: string) => void;
  showInline?: boolean;
}>({ showInline: true });
